/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Selectors
 */
import { getUserErrorState } from '../../../selectors/user'

/**
 * Import
 * - Actions
 */
import { fetchRecoverPassword } from '../../../actions'

/**
 * Import
 * - Page component
 */
import { Recover } from '../../../components/pages/Recover/Recover'

/**
 * Map variables from global state to component props
 * @return {object} [description]
 */
const mapStateToProps = (state: RootState) => {
  return {
    userError: getUserErrorState(state),
    recoverSuccess: state.user.recoverSuccess,
  }
}

/**
 * Connect (props, dispach functions)(component)
 */
export default connect(mapStateToProps, { recoverpassword : fetchRecoverPassword })(Recover)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Login/Recover.tsx